var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 399.944,
    height: 111.502,
    viewBox: "0 0 399.944 111.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-131.498 -225.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M131.5,238.472h0V225.159h11.982v13.313H153.8v9.707H143.481v16.171c0,4,2.246,5.659,5.492,5.659,1.914,0,7.62.049,7.62.049v10.436h-9.619c-8.9,0-15.475-5.575-15.475-15.476V247.626h0Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M300.573,270.724h6.6l-.121-12.482h11.982l.121,12.482h10.318l-.121,9.7H319.037v17.012c0,3.994,2.246,5.659,5.492,5.659,1.914,0,7.62.049,7.62.049v10.436h-9.617c-8.9,0-15.477-5.576-15.477-15.478V280.422h-8.581Z",
    transform: "translate(114.407 22.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M150.828,233.4H162.81v4.659l.5.167a14.8,14.8,0,0,1,11.4-5.659h1.164v11.151h-2a17.3,17.3,0,0,0-11.068,3.827v27.542H150.828Z",
    transform: "translate(13.244 5.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M200.353,236.227l.415-.249V233.4H212.75V275H200.767v-3.994l-.5-.167a16.185,16.185,0,0,1-12.233,4.993c-11.232,0-20.052-9.568-20.052-21.634s9.152-21.636,20.884-21.636C194.111,232.565,197.688,234.063,200.353,236.227Zm.415,24.13V245.214a18.524,18.524,0,0,0-10.4-2.829c-5.743,0-10.4,4.909-10.4,11.816,0,6.823,4.659,11.815,10.4,11.815C194.61,266.015,198.6,264.517,200.767,260.357Z",
    transform: "translate(24.999 5.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M200.719,233.4H212.7v4.744l.5.165c2.829-3.328,7.654-5.741,13.9-5.741,8.239,0,15.06,5.908,15.06,17.475V275H230.176V250.7c0-5.824-3.662-8.32-8.072-8.32-3.744,0-7.155,1.164-9.4,3.662V275H200.719Z",
    transform: "translate(47.428 5.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M230.011,265.684h14.61c3.5,0,6.242-1,6.242-3.413,0-1.914-1.166-3.244-6.491-4.326-7.988-1.665-13.063-5.576-13.063-12.233,0-8.738,7.821-13.148,16.476-13.148h13.07l-.143,10.123s-8.6-.137-12.261-.137c-2.829,0-5.325,1.08-5.325,3.161,0,1.663.915,3.079,6.49,4.161,8.156,1.663,13.149,4.991,13.149,12.066,0,9.4-8.406,13.111-17.393,13.111-4.909,0-15.276-.094-15.276-.094Z",
    transform: "translate(67.498 5.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M177.031,265.649c13.232,0,23.05,9.568,23.05,21.634s-9.818,21.636-23.05,21.636c-13.313,0-23.05-9.57-23.05-21.636S163.718,265.649,177.031,265.649Zm0,33.451c6.407,0,11.068-4.909,11.068-11.816,0-6.823-4.661-11.815-11.068-11.815-6.491,0-11.066,4.991-11.066,11.815C165.964,294.191,170.539,299.1,177.031,299.1Z",
    transform: "translate(15.405 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M186.11,266.482h11.983v4.742l.5.167c2.831-3.328,7.656-5.741,13.9-5.741,8.237,0,15.06,5.908,15.06,17.473v24.964H215.568v-24.3c0-5.824-3.664-8.32-8.072-8.32-3.744,0-7.155,1.164-9.4,3.66v28.958H186.11Z",
    transform: "translate(37.418 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M216.758,266.482h11.981v4.742l.5.167c2.829-3.328,7.656-5.741,13.9-5.741,8.239,0,15.062,5.908,15.062,17.473v24.964H246.215v-24.3c0-5.824-3.662-8.32-8.072-8.32-3.743,0-7.155,1.164-9.4,3.66v28.958H216.758Z",
    transform: "translate(58.417 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M154.3,299.1a15.864,15.864,0,0,0,8.4-1.914l2.329,9.4a22.151,22.151,0,0,1-10.733,2.331c-12.816,0-22.8-9.57-22.8-21.636s9.985-21.634,22.8-21.634h11.673l-2.459,9.819H154.3a11.429,11.429,0,0,0-11.484,11.815C142.814,294.191,147.891,299.1,154.3,299.1Z",
    transform: "translate(0 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M297.933,299.1a15.864,15.864,0,0,0,8.4-1.914l2.331,9.4a22.161,22.161,0,0,1-10.734,2.331c-12.814,0-22.8-9.57-22.8-21.636s9.985-21.634,22.8-21.634h11.722l-2.508,9.819h-9.214a11.427,11.427,0,0,0-11.483,11.815C286.45,294.191,291.526,299.1,297.933,299.1Z",
    transform: "translate(98.414 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M344.887,265.649c13.23,0,23.05,9.568,23.05,21.634s-9.819,21.636-23.05,21.636c-13.313,0-23.05-9.57-23.05-21.636S331.574,265.649,344.887,265.649Zm0,33.451c6.407,0,11.068-4.909,11.068-11.816,0-6.823-4.661-11.815-11.068-11.815-6.491,0-11.067,4.991-11.067,11.815C333.82,294.191,338.4,299.1,344.887,299.1Z",
    transform: "translate(130.414 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M353.966,266.482h11.982v4.659l.5.167a14.8,14.8,0,0,1,11.4-5.659h1.166V276.8h-2a17.293,17.293,0,0,0-11.068,3.829v27.542H353.966Z",
    transform: "translate(152.427 27.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 185.979,
    height: 6.529,
    transform: "translate(345.462 255.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M287.662,285.785v4.992H258.122c.834,5.743,4.494,8.239,12.315,8.323a29.22,29.22,0,0,0,12.233-2.5l2.079,8.738a29.923,29.923,0,0,1-14.312,3.579c-14.978,0-24.464-8.156-24.464-21.552,0-11.4,7.823-21.552,21.3-21.718C279.175,265.649,287.412,272.637,287.662,285.785Zm-29.206-2.828H275.6c-.5-5.409-3.746-7.489-7.905-7.489C262.45,275.468,259.538,278.131,258.456,282.957Z",
    transform: "translate(78.435 27.742)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.eabb204843b3957de2988b63bb7efd76.svg";
export { ForwardRef as ReactComponent };